import { SERVICE_STATES } from "@/constants/states";
import { MapPin } from "lucide-react";

export default function ServiceAreas() {
  return (
    <section
      id="areas"
      data-testid="service-areas-section"
      className="bg-[#F1EDE7] py-20 lg:py-28 tr-grain"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs uppercase tracking-[0.2em] text-[#D95D39] font-medium">
            Service Areas
          </span>
          <h2 className="mt-3 font-[Outfit] font-semibold text-[#2C3D30] text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Buying single-family homes in 7 states.
          </h2>
          <p className="mt-4 text-[#5B6B5F] text-base lg:text-lg">
            Whether you&apos;re in a Philadelphia row home, a Charlotte ranch, or a Houston bungalow — we can help.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-3 sm:gap-4">
          {SERVICE_STATES.map((s, idx) => (
            <div
              key={s.code}
              data-testid={`area-state-${s.code}`}
              className="group bg-white border border-[#E2DDD7] hover:border-[#D95D39] hover:bg-[#D95D39] hover:text-white rounded-full pl-3 pr-5 py-2.5 flex items-center gap-2 transition-all duration-300 tr-fade-up cursor-default"
              style={{ animationDelay: `${idx * 60}ms` }}
            >
              <div className="w-7 h-7 rounded-full bg-[#F1EDE7] group-hover:bg-white/15 flex items-center justify-center transition-colors">
                <MapPin strokeWidth={1.75} className="w-3.5 h-3.5 text-[#D95D39] group-hover:text-white" />
              </div>
              <span className="font-[Outfit] font-medium text-sm text-[#2C3D30] group-hover:text-white">{s.name}</span>
              <span className="text-xs text-[#5B6B5F] group-hover:text-white/80 font-mono">{s.code}</span>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-[#5B6B5F]">
          Don&apos;t see your state? <a href="#lead-form" className="text-[#D95D39] underline underline-offset-4">Reach out anyway</a> — we may still be able to help.
        </p>
      </div>
    </section>
  );
}
